<template>
  <select
    v-model="dataModel"
    :style="optionStyle"
    @change="onChange($event)"
  >
    <option
      selected
      :value="null"
      style="color: gray; font-style: italic; display: none;"
    >
      {{ placeHolder }}
    </option>
    <option
      v-for="(item, index) in items"
      :key="index"
      :value="item"
      style="font-style: normal"
    >
      {{ item }}
    </option>
  </select>
</template>
<script>
export default {
  props: {
    placeHolder: {
      type: String,
      required: false,
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    passInValue: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      dataModel: null
    }
  },

  computed: {
    passInFiltered () {
      if (this.passInValue === '' || this.passInValue === undefined || this.passInValue === '00000000-0000-0000-0000-000000000000') {
        return null
      } else {
        return this.passInValue
      }
    },

    optionStyle () {
      if (this.dataModel === null) {
        return {
          'color': 'gray',
          'font-style': 'italic'
        }
      } else {
        return null
      }
    }
  },

  watch: {
    passInValue: function () {
      this.dataModel = this.passInFiltered
    }
  },

  created () {
    this.dataModel = this.passInFiltered
  },

  methods: {
    onChange (event) {
      this.$emit('onchange', event.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>

select {
  width: 100%;
  height: 25px;
  color: black !important;
  padding-left: 10px;

  option {
    color: #201f1f;
  }
}
select[disabled] {
  background-color: #EBEBE4;
  cursor: no-drop;
}
</style>



// WEBPACK FOOTER //
// src/components/dropdown/selectDropDown.vue